import { getTrackingKey } from '@/utils/api'

import API from './base'

class UserFeedbackApi extends API {
  fetchFeedbackAnswers = (options = {}) => {
    const questionCode = options?.questionCode ?? ''

    let path = this.uri + '/questions'
    if (questionCode !== '') path = `${path}?question=${questionCode}`

    return this.fetcher(
      {
        method: 'GET',
        trackingKey: getTrackingKey(path),
        path,
      },
      { options: { attachToken: false } }
    )
  }

  submitFeedback = (payload) => {
    return this.fetcher(
      {
        method: 'POST',
        trackingKey: getTrackingKey(this.uri),
        path: this.uri,
        data: this.transformData(payload),
      },
      { options: { attachToken: false } }
    )
  }
}

export default new UserFeedbackApi('/checkout/user_feedback')
